var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.741,
    height: 38.746,
    viewBox: "0 0 38.741 38.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846",
    transform: "translate(644.559 -547.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M-549.219,811.5h10.306l4.214,1.763,1.958,2.773s.571,3.026.571,3.389-.082,4.36-.082,4.36a19.35,19.35,0,0,1-12.113,4.323,19.894,19.894,0,0,1-12.276-4.4v-6.73S-554.848,811.5-549.219,811.5Z",
    transform: "translate(-80.82 -242.69)",
    fill: "#ff4e4e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845",
    transform: "translate(-644.559 547.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M-625.186,547.5a19.373,19.373,0,0,0-19.373,19.373,19.373,19.373,0,0,0,19.373,19.373q.875,0,1.744-.078c.538-.048,1.071-.122,1.6-.214l.2-.036A19.373,19.373,0,0,0-605.9,565.093,19.373,19.373,0,0,0-625.186,547.5Zm-1.556,37.386h-.046c-.5-.045-1-.112-1.495-.2l-.085-.014q-.725-.13-1.434-.319l-.115-.029c-.462-.125-.918-.271-1.368-.432-.047-.017-.094-.031-.14-.049-.441-.162-.874-.344-1.3-.54-.053-.024-.106-.046-.159-.072-.418-.194-.829-.412-1.231-.641l-.171-.1q-.594-.347-1.163-.741l-.173-.119q-.559-.4-1.091-.839l-.1-.085v-4.153a7.112,7.112,0,0,1,7.1-7.1h9.041a7.112,7.112,0,0,1,7.1,7.1v4.154l-.086.072q-.541.452-1.112.856l-.152.1q-.576.4-1.181.754l-.152.086c-.408.232-.824.452-1.247.65-.049.023-.1.044-.147.065-.43.2-.867.381-1.311.544l-.129.046c-.452.162-.911.309-1.375.435l-.111.028c-.474.125-.952.233-1.436.32l-.083.013c-.495.086-.994.154-1.5.2h-.046c-.517.044-1.033.068-1.556.068S-626.227,584.932-626.742,584.887Zm14.472-5.37v-3.422c-.005-4.634-3.761-7.924-8.395-7.929h-9.041a8.4,8.4,0,0,0-8.4,8.4v2.956a18.082,18.082,0,0,1,.173-25.484,18.082,18.082,0,0,1,25.484,0,18.082,18.082,0,0,1,.173,25.484Z",
    transform: "translate(644.559 -547.501)",
    fill: "#5a6168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M-478.1,627.5a6.458,6.458,0,0,0-6.458,6.458,6.458,6.458,0,0,0,6.458,6.458,6.458,6.458,0,0,0,6.458-6.458A6.465,6.465,0,0,0-478.1,627.5Zm0,11.624a5.166,5.166,0,0,1-5.166-5.166,5.166,5.166,0,0,1,5.166-5.166,5.166,5.166,0,0,1,5.166,5.166A5.172,5.172,0,0,1-478.1,639.125Z",
    transform: "translate(497.474 -621.043)",
    fill: "#5a6168"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843",
    transform: "translate(12.915 7.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M-484.559,704.474c0-.089,0-.177.007-.266Q-484.559,704.34-484.559,704.474Z",
    transform: "translate(484.559 -699.308)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M-459.518,649.141a5.166,5.166,0,0,0-4.52-5.124,5.166,5.166,0,0,0-4.52,5.124,5.166,5.166,0,0,0,4.518,5.124A5.172,5.172,0,0,0-459.518,649.141Z",
    transform: "translate(469.85 -643.975)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M-340.647,704.139c0,.09.007.18.007.271Q-340.64,704.274-340.647,704.139Z",
    transform: "translate(352.264 -699.244)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M-484.552,707.767c0-.088-.007-.177-.007-.266Q-484.559,707.635-484.552,707.767Z",
    transform: "translate(484.559 -702.335)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M-411.831,643.338a7.53,7.53,0,0,0-.758.2,5.166,5.166,0,0,1,4.52,5.125,5.172,5.172,0,0,1-4.523,5.124,7.5,7.5,0,0,0,.761.2,5.662,5.662,0,0,0,5.56-5.328c0-.091,0-.241,0-.331A5.637,5.637,0,0,0-411.831,643.338Z",
    transform: "translate(418.401 -643.501)",
    fill: "#5a6168"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844",
    transform: "translate(7.749 20.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M-541.364,819.5h-.091a7.112,7.112,0,0,0-7.1,7.1v4.153l.1.085c.354.294.718.575,1.091.839l.173.119q.569.393,1.162.741l.171.1c.4.23.813.448,1.231.641.053.025.106.048.159.072.427.2.86.378,1.3.54.047.017.094.032.14.049.45.161.907.307,1.368.432l.114.029q.71.188,1.434.319l.085.014c.494.086.993.153,1.495.2h.046c.516.044,1.036.064,1.56.064s1.04-.024,1.556-.068h.046c.5-.045,1-.112,1.5-.2l.083-.013c.484-.087.962-.195,1.436-.32l.111-.028c.464-.126.923-.272,1.375-.434l.129-.046c.444-.163.881-.346,1.311-.544.049-.021.1-.042.147-.065.424-.2.839-.417,1.247-.65l.152-.086q.6-.354,1.181-.754l.152-.1q.571-.4,1.112-.856l.086-.072V826.6a7.112,7.112,0,0,0-7.1-7.1h-.091a6.434,6.434,0,0,1-4.429,1.761A6.433,6.433,0,0,1-541.364,819.5Z",
    transform: "translate(548.559 -818.209)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M-455,821.262a6.434,6.434,0,0,0,4.429-1.761h-8.858A6.433,6.433,0,0,0-455,821.262Z",
    transform: "translate(466.623 -818.209)",
    fill: "#5a6168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M-471.173,803.5a8.513,8.513,0,0,0-.932.053,6.485,6.485,0,0,0,1.023,1.239h8.858a6.48,6.48,0,0,0,1.023-1.239,8.511,8.511,0,0,0-.932-.053Z",
    transform: "translate(478.276 -803.501)",
    fill: "#5a6168"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.ca4236238907f6ad3430d9faf7383441.svg";
export { ForwardRef as ReactComponent };